import React, { FC } from 'react';
import Widget from 'shared/components/Widget';
import 'modules/hiring/components/candidatesAwaitingReview/candidatesAwaitingReview.scss';
import { SxProps } from '@mui/system';
import RecentHiringActivityGroupedList from '../recentHiringActivity/recentHiringActivityGroupedList';
import { IRecentHiringActivityCardData } from '../recentHiringActivity/recentHiringActivityCard';

export interface ICandidateApplicationActivityProps {
  i18nKey?: string;
  recentHiringActivityGroupedListSxProps?: SxProps;
  enableDateTextSuffixForRHAGroupedList?: boolean;
  recentDaysLimit?: number;
  relativeDaysLimit?: number;
  i18nKeyForEmptyState?: string;
  data: IRecentHiringActivityCardData[];
}

const CandidateApplicationActivity: FC<ICandidateApplicationActivityProps> = ({
  i18nKey = 'activity',
  recentHiringActivityGroupedListSxProps,
  enableDateTextSuffixForRHAGroupedList = false,
  recentDaysLimit = 0,
  i18nKeyForEmptyState,
  data,
}) => {
  return (
    <Widget
      id='candidate-application-activity-widget'
      headingProps={{
        i18nKey,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      withDivider
    >
      <RecentHiringActivityGroupedList
        id='candidate-application-activities'
        className='innerContainer'
        sx={{
          pr: ({ typography }) => typography.pxToRem(8),
          mr: ({ typography }) => typography.pxToRem(-16),
          pt: ({ typography }) => typography.pxToRem(8),
          maxHeight: 'auto',
          height: 'auto !important',
          minHeight: '3rem',
          ...recentHiringActivityGroupedListSxProps,
        }}
        data={data}
        recentDaysLimit={recentDaysLimit}
        enableDateTextSuffix={enableDateTextSuffixForRHAGroupedList}
        i18nKeyForEmptyState={i18nKeyForEmptyState}
      />
    </Widget>
  );
};

export default CandidateApplicationActivity;
